import store from '@/script/store'


setTimeout(() => {
  const userAgentto = navigator.userAgent.toLowerCase(); //获取当前浏览器
  var res = /(msie|edg|firefox|chrome|opera|version).*?([\d.]+)/;

  let oop = userAgentto.match(res);
  let container = {};
  try {
    container.browser = oop[1].replace(/version/, "'safari");
    container.ver = oop[2];
  } catch (e) {
    console.log("getContainer error!")
    container = null;
  }
  if (container != null) {
    switch (container.browser) {
      case "chrome":
        break;
      case "firefox":
        // let paths = document.getElementsByClassName("path3");
        // document.getElementsByClassName("message")[0].style.maxHeight="120px";
        // for(let i = 0; i < paths.length;i++){
        //   paths[i].style.marginLeft="-0.5em";
        // }
        break;
      case "opera":
        
        break;
      case "'safari":
       
        break;
      case "android":
       
        break;
      case "iphone":
     
        break;
      default:
        break;
    }
    console.log(container.browser)
    console.log(container.ver)
    store.commit("setEquipment",container.browser)
    store.commit("setEquipmentEdition",container.ver)
  }
}, 1000);



// WEBPACK FOOTER //
// ./src/script/maketime/time.js